import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Moment from 'react-moment';
import moment from 'moment';
import { useSignals } from '@preact/signals-react/runtime';
import { SttContainer, SttTranslateHook, SttHidden } from '@stt-componentes/core';
import { SttTable, SttTableHead, SttTableBody, SttTableRow, SttTableCell, SttTableCard, SttSeeButton } from '@stt-componentes/core-v2';
import { Chip, IconButton } from '@material-ui/core';
import { ListaExames } from '@stt-utilitarios/core';
import DadosExame from '../exame/dados-exame';

const VisualizacaoExame = (props) => {
	return (
		<SttContainer>
			<DadosExame
				{...props}
				ocultarBotoes={true}
			/>
		</SttContainer>
	);
};

const HistoricoPaciente = (props) => {
	const { historico, abas, abaAtiva } = props;
	const { strings } = useContext(SttTranslateHook.I18nContext);

	const abrirExame = (exame) => {
		const titulo = `Data do exame: ${moment(exame.data).format('DD/MM/YYYY')}\nRequisição: ${exame.requisicao}`;
		const aba = {
			titulo: titulo,
			id: exame.id,
			conteudo: VisualizacaoExame
		};
		abas.value.push(aba);
		abaAtiva.value = abas.value.length - 1 + '';
	};

	useSignals();

	return (
		<>
			<SttHidden smDown>
				<SttTable>
					<SttTableHead>
						<SttTableRow>
							<SttTableCell>{strings.dataExame}</SttTableCell>
							<SttTableCell>{strings.requisicao}</SttTableCell>
							<SttTableCell>{strings.descricao}</SttTableCell>
							<SttTableCell>{strings.situacao}</SttTableCell>
							<SttTableCell align="center">{strings.opcoes}</SttTableCell>
						</SttTableRow>
					</SttTableHead>
					<SttTableBody>
						{historico.map((row, index) => (
							<SttTableRow key={index}>
								<SttTableCell>{<Moment format="DD/MM/YYYY HH:mm">{row.data}</Moment>}</SttTableCell>
								<SttTableCell>{row.requisicao}</SttTableCell>
								<SttTableCell>{row.descricao}</SttTableCell>
								<SttTableCell>
									<Chip
										style={{ backgroundColor: ListaExames.getCorLegenda(row) }}
										label={ListaExames.getTextoLegenda(row, strings)}
										size="small"
									/>
								</SttTableCell>
								<SttTableCell align="center">
									<IconButton>
										<VisibilityIcon onClick={() => abrirExame(row)} />
									</IconButton>
								</SttTableCell>
							</SttTableRow>
						))}
					</SttTableBody>
				</SttTable>
			</SttHidden>
			<SttHidden mdUp>
				{historico.map((row, index) => (
					<SttTableCard
						key={index}
						cor={ListaExames.getCorLegenda(row, true)}
						titulo={row.descricao}
						acao={<SttSeeButton onClick={() => abrirExame(row)} />}
						conteudo={[
							[
								{ titulo: strings.data, valor: moment(row.data_exame).format('DD/MM/YYYY HH:mm'), xs: 6 },
								{ titulo: strings.situacao, valor: ListaExames.getTextoLegenda(row, strings), xs: 6 }
							],
							[{ titulo: strings.requisicao, valor: row.requisicao }]
						]}
					/>
				))}
			</SttHidden>
		</>
	);
};

HistoricoPaciente.propTypes = {
	historico: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default HistoricoPaciente;
